import React, {useContext} from "react";

export const Lotto6Context = React.createContext();

export const useLotto6 = () => useContext(Lotto6Context);
